import React from "react";
import { Image } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import "./GameThumbnailsHero.scss";
import ImageSigmaGamesLogo from "../../images/sigma-games-logo.png";
import ImageGameThumbnails from "../../images/vertical-card-carousel.png";
import GhostButton from "../dashboard-page/GhostButton/GhostButton";
import ChevronLeftCircleIcon from "../icons/ChevronLeftCircleIcon";

function GameThumbnailsHero() {
  const navigate = useNavigate();

  return (
    <header className="game-thumbnails-hero">
      <div className="game-thumbnails-hero__nav">
        <GhostButton
          onClick={() => navigate(-1)}
          className="p-0 game-thumbnails-hero__back-btn"
        >
          <ChevronLeftCircleIcon
            chevronColor="white"
            bgColor="#FFFFFF1A"
            width={32}
            height={32}
          />
        </GhostButton>
        <Link to="/">
          <Image
            src={ImageSigmaGamesLogo}
            className="game-thumbnails-hero__logo"
            width={114.58}
            height={24}
          />
        </Link>
      </div>
      <Image src={ImageGameThumbnails} className="game-thumbnails-hero__image" />
    </header>
  );
}

export default GameThumbnailsHero;
